define({
    root: ({
        maximizeSomething: "Maximize {placeholder}",
        restoreSomething: "Restore {placeholder}",
        maximize: "Maximize",
        restore: "Restore",
        collapse: "Collapse",
        expand: "Expand",
        undock: "Undock",
        undockSomething: "Undock {placeholder}",
        dock: "Dock",
        dockSomething: "Dock {placeholder}",
        close: "Close",
        closeSomething: "Close {placeholder}",
        closeAll: "Close All",
        tile: "Tile",
        tileAll: "Tile All",
        subtile: "Sub-Tile",
        subtileSomething: "Sub-Tile {placeholder}",
        tabPosition: "Tab Position",
        shrinkTabsToFit: "Shrink Tabs to Fit",
        top: "Top",
        bottom: "Bottom",
        left: "Left",
        right: "Right",
        document: "Document",

        splitTitle: "Split",
        noSplitLabel: "None",
        noSplitDescription: "Display one document",
        leftRightSplitLabel: "Left/Right",
        leftRightSplitDescription: "Display two documents, side-by-side",
        topBottomSplitLabel: "Top/Bottom",
        topBottomSplitDescription: "Display two documents, one above other",
        singleTileLabel: "Single",

        tabPositionTitle: "Tabs",
        tabsToTopLabel: "Top",
        tabsToTopDescription: "Place tabs at top",
        tabsToBottomLabel: "Bottom",
        tabsToBottomDescription: "Place tabs at bottom",
        tabsToLeftLabel: "Left",
        tabsToLeftDescription: "Place tabs at left",
        tabsToRightLabel: "Right",
        tabsToRightDescription: "Place tabs at right",

        shrinkTabsLabel: "Shrink to Fit",
        shrinkTabsDescription: "Shrink tabs to forestall scrolling",

        collapseSidePanel: "Collapse Side",
        expandSidePanel: "Expand Side",
        collapseBottomPanel: "Collapse Bottom",
        expandBottomPanel: "Expand Bottom",
        collapseTopPanel: "Collapse Top",
        expandTopPanel: "Expand Top",
        expandDocuments: "Expand Documents",

        childActions: "{placeholder} Actions"
    })
});